// --- BusinessAlert.tsx ---
import React from "react";
import { BusinessRule } from "../../domain/types";

interface BusinessAlertProps {
  rules: BusinessRule[];
  onRecover?: (amount: number) => void;
}

export const BusinessAlert: React.FC<BusinessAlertProps> = ({ 
  rules, 
  onRecover 
}) => {
  const activeRules = rules.filter(r => r.active);
  if (activeRules.length === 0) return null;

  return (
    <div role="alert" className="space-y-3">
      {activeRules.map((rule, idx) => (
        <div 
          key={idx}
          className="border-l-4 border-[#ff3b3b] bg-[#2a0f0f] p-4"
        >
          {rule.type === "KIO_WARNING" && (
            <>
              <div className="text-[#ff3b3b] font-black text-sm uppercase mb-2">
                🚨 ALERT KIO — RYZYKO ODRZUCENIA
              </div>
              <div className="text-white text-sm">
                {rule.message}
              </div>
            </>
          )}
          
          {rule.type === "HYDRO_MISSING" && (
            <>
              <div className="text-[#ff3b3b] font-black text-sm uppercase mb-2">
                ⚠ BRAK: Hydroizolacja
              </div>
              <div className="text-[#ff3b3b] text-lg font-bold mb-2">
                {rule.lossAmount} zł do sprawdzenia
              </div>
              {onRecover && (
                <button
                  type="button"
                  onClick={() => onRecover(rule.lossAmount)}
                  className="w-full min-h-[44px] bg-[#00e676] text-black font-black 
                           text-sm uppercase hover:bg-[#00c853]
                           focus:ring-2 focus:ring-[#00e676] focus:outline-none"
                >
                  Dolicz {rule.lossAmount} zł
                </button>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
};
